import React, { useState } from 'react';
import { Sidebar } from '../../../components/Sidebar';
import { Header } from '../../../components/Header';
import { CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const ANIMATION_STYLES = [{
  id: 'zoom',
  name: 'Zoom In',
  desc: 'Smooth zoom into product'
}, {
  id: 'rotate',
  name: '3D Rotate',
  desc: 'Product rotation effect'
}, {
  id: 'pan',
  name: 'Camera Pan',
  desc: 'Cinematic panning motion'
}, {
  id: 'parallax',
  name: 'Parallax',
  desc: 'Layered depth effect'
}];
const DURATIONS = [{
  id: '4',
  label: '4 seconds'
}, {
  id: '6',
  label: '6 seconds'
}, {
  id: '8',
  label: '8 seconds'
}];
export function VideoConfiguration() {
  const navigate = useNavigate();
  const [selectedAnimation, setSelectedAnimation] = useState('zoom');
  const [selectedDuration, setSelectedDuration] = useState('6');
  const [addText, setAddText] = useState(true);
  const [textContent, setTextContent] = useState('Limited Time Offer');
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1543">
      <Sidebar data-id="element-1544" />
      <main className="flex-1" data-id="element-1545">
        <Header data-id="element-1546" />
        <div className="px-6 py-8" data-id="element-1547">
          <div className="max-w-5xl mx-auto" data-id="element-1548">
            <div className="mb-6" data-id="element-1549">
              <button onClick={() => navigate('/dealer/video-generator/upload')} className="text-sm text-blue-500 hover:text-blue-600 mb-2 transition-colors" data-id="element-1550">
                ← Back to Upload
              </button>
              <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1551">
                Configure Video Settings
              </h1>
              <p className="text-gray-600" data-id="element-1552">
                Choose animation style and video duration
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6" data-id="element-1553">
              <div className="col-span-2 space-y-6" data-id="element-1554">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1555">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1556">
                    Animation Style
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1557">
                    {ANIMATION_STYLES.map(style => <button key={style.id} onClick={() => setSelectedAnimation(style.id)} className={`p-4 rounded-lg border-2 transition-all text-left ${selectedAnimation === style.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1558">
                        <div className="flex items-center justify-between mb-2" data-id="element-1559">
                          <span className="font-medium text-gray-800" data-id="element-1560">
                            {style.name}
                          </span>
                          {selectedAnimation === style.id && <CheckCircleIcon className="text-blue-500 flex-shrink-0" size={20} data-id="element-1561" />}
                        </div>
                        <p className="text-sm text-gray-500" data-id="element-1562">{style.desc}</p>
                      </button>)}
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1563">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1564">
                    Video Duration
                  </h3>
                  <div className="flex space-x-4" data-id="element-1565">
                    {DURATIONS.map(duration => <button key={duration.id} onClick={() => setSelectedDuration(duration.id)} className={`flex-1 px-4 py-3 rounded-md text-sm font-medium transition-colors ${selectedDuration === duration.id ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1566">
                        {duration.label}
                      </button>)}
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1567">
                  <div className="flex items-center justify-between mb-4" data-id="element-1568">
                    <h3 className="font-medium text-gray-800" data-id="element-1569">
                      Add Text Overlay
                    </h3>
                    <label className="flex items-center cursor-pointer" data-id="element-1570">
                      <input type="checkbox" checked={addText} onChange={e => setAddText(e.target.checked)} className="mr-3 w-4 h-4 text-blue-500 rounded focus:ring-2 focus:ring-blue-500" data-id="element-1571" />
                      <span className="text-sm text-gray-700" data-id="element-1572">Enable</span>
                    </label>
                  </div>
                  {addText && <div data-id="element-1573">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1574">
                        Text Content
                      </label>
                      <input type="text" value={textContent} onChange={e => setTextContent(e.target.value)} placeholder="Enter text to display" maxLength={50} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1575" />
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1576">
                        {textContent.length}/50 characters • Appears at 2-3
                        seconds
                      </p>
                    </div>}
                </div>
              </div>

              <div className="space-y-6" data-id="element-1577">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1578">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1579">Preview</h3>
                  <div className="w-full h-64 bg-gradient-to-br from-green-100 to-green-200 rounded-lg flex items-center justify-center" data-id="element-1580">
                    <p className="text-center text-gray-700 font-medium" data-id="element-1581">
                      Video preview will appear here
                    </p>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-1582">
                  <h4 className="font-medium text-green-900 mb-2" data-id="element-1583">
                    Configuration Summary
                  </h4>
                  <ul className="text-sm text-green-800 space-y-1" data-id="element-1584">
                    <li data-id="element-1585">
                      • Animation:{' '}
                      {ANIMATION_STYLES.find(s => s.id === selectedAnimation)?.name}
                    </li>
                    <li data-id="element-1586">• Duration: {selectedDuration} seconds</li>
                    <li data-id="element-1587">• Text overlay: {addText ? 'Enabled' : 'Disabled'}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-6" data-id="element-1588">
              <button onClick={() => navigate('/dealer/video-generator/upload')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1589">
                Back
              </button>
              <button onClick={() => navigate('/dealer/video-generator/generate')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1590">
                Continue to Generate
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}